import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import { UserShowPageProps } from "./show.props";
import UserNav from "components/profile/UserNav";
import UserHeader from "components/profile/UserHeader";
import ProfileReviews from "components/profile/ProfileReviews";
import ProfilePins from "components/profile/ProfilePins";
import ProfileGoals from "components/profile/ProfileGoals";
import ProfileBooksByStatus from "components/profile/ProfileBooksByStatus";
import CoverLayout from "layouts/CoverLayout";
import ProfileSimilarBooks from "components/profile/ProfileSimilarBooks";

function UserShowPage() {
  const { user, similarComparison } = usePage<UserShowPageProps>().props;

  return (
    <CoverLayout cover={user.cover}>
      <UserHeader user={user} />
      <UserNav user={user} />
      <div className="mt-4 space-y-16">
        <ProfileBooksByStatus user={user} lists={user.statusLists} />
        <ProfileSimilarBooks user={user} similarComparison={similarComparison} />
        <ProfileGoals user={user} goals={user.goals} />
        <ProfilePins user={user} prompts={user.pinnedPrompts} lists={user.pinnedLists} /> 

        <ProfileReviews reviews={user.reviews} user={user} />
      </div>
    </CoverLayout>
  );
}

UserShowPage.layout = DefaultLayoutWrapper;
export default UserShowPage;